/*eslint-disable */

import Vue from 'vue'
import VueCircle from 'vue2-circle-progress/src/index.vue'
import axios from 'axios';
import {
  bus
} from '@/main';
import feedbackForm from '../contestFeedbackForm/index';
import moment from 'moment';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

var interval;
var $ = window.jQuery = require('jquery');
export default {
  name: 'contest-quizzort',
  components: {
    VueCircle,
    'feedback-form': feedbackForm
  },
  props: ['quizInfo', 'totalTime', 'quizInst'],
  data() {
    return {
      fill: {
        color: "#0cbfe9"
      },
      questionIndex: 0,
      userResponses: [],
      quizResponses: [],
      quizStarted: true,
      isActive: false,
      totalScore: 0,
      quizId: '',
      quizSubmitted: false,
      QuizStart: false,
      quizSectionShow: false,
      quizInstructionsShow: true,
      CountDown: {
        minutes: "00",
        seconds: "00"
      },
      questionIndexs: ['', 'A', 'B', 'C', 'D'],
      newArray: [],
      sectionQuestion: '',
      sectionQuestionList: [],
      sectionQuestionListResults: [],
      selectedQuestionId: '',
      selectedOptionData: '',
      selectedQuestionIndex: '',
      sectionByTotalTime: '',
      selectedOptionIndex: '',
      selectedOptionId: '',
      startTimerCheck: true,
      skipQuestion: true,
      contestFeedbackTrue: false,
      checkContestFeedbackButton: true,
      countdownTimerForFullScreenInterval:false,
      downloadTimer:''
    }
  },
  computed: {},
  mounted() {
    $('.quizloader, .courseloader').hide();
    this.quizId = this.quizInfo.id;
    this.renderMathJax()
    setInterval(() => {
      this.renderMathJax()
    }, 10);
    bus.$on('contestFeedbackBus', (data) => {
      this.contestFeedbackTrue = data;
    })
    bus.$on('checkContestFeedbackBtnBus', (data) => {
      this.checkContestFeedbackButton = data;
    })
    if(this.quizInfo && !this.quizInfo.is_completed){
      this.countdownTimer();
    }
    document.addEventListener("fullscreenchange", this.exitFullscreenHandler);
    document.addEventListener("webkitfullscreenchange", this.exitFullscreenHandler);
    document.addEventListener("mozfullscreenchange", this.exitFullscreenHandler);
    document.addEventListener("MSFullscreenChange", this.exitFullscreenHandler);
  },
  methods: {
    // Handler for exiting fullscreen
    exitFullscreenHandler() {
      if (!document.fullscreenElement && !document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement) {
        // Fullscreen mode has been exited
        if(!this.quizSubmitted && this.QuizStart){
          this.countdownTimerForFullScreen();
        }
        // You can add your custom logic here
      }
    },
    openFullscreen() {
      clearInterval(this.downloadTimer);
      this.countdownTimerForFullScreenInterval = false
      const elem = document.documentElement;
      if (!document.fullscreenElement && !document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement) {
        // If not in fullscreen, request fullscreen
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        }
      }
    },
    feedbackFormActive() {
      this.contestFeedbackTrue = true
    },
    countdownTimerForFullScreen() {
      this.countdownTimerForFullScreenInterval = true
      var timeleft = 6;
      this.downloadTimer = setInterval(() => {
      timeleft--;
      document.getElementById("js-timeout-full-screen").textContent = timeleft;
      if(timeleft <= 0){
        if(this.countdownTimerForFullScreenInterval){
          this.submitQuiz();
          this.countdownTimerForFullScreenInterval = false
        }
        clearInterval(this.downloadTimer);
      }
      },1000);
    },
    countdownTimer() {
      var __self = this
      clearInterval(interval);
      interval = setInterval(function () {
        var timer = $('.js-timeout').html();
        timer = timer.split(':');
        var minutes = timer[0];
        var seconds = timer[1];
        seconds -= 1;
        if (minutes < 0) return;
        else if (seconds < 0 && minutes != 0) {
          minutes -= 1;
          seconds = 59;
        } else if (seconds < 10 && length.seconds != 2) seconds = '0' + seconds;
        $('.js-timeout').html(minutes + ':' + seconds);
        if (minutes == 0 && seconds == 0) {
          __self.startTimerCheck = false
          clearInterval(interval)
        };
      }, 1000);
    },
    renderMathJax() {
      setTimeout(() => {
        if (window.MathJax) {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log());
        }
      }, 100)
    },
    contestSectionShow() {
      this.quizInstructionsShow = false
      this.startQuizMethod();
    },
    getCounter() {
      let startIndex = this.questionIndex;
      let maxCount = 5;
      let maxQuestions = this.sectionQuestionListResults.length;
      let finalArray = [];
      let maxNumber = maxCount + startIndex;
      if (maxQuestions > 5) {
        for (let i = startIndex; i < maxNumber; i++) {
          finalArray.push(i + 1);
        }
        if (maxNumber <= maxQuestions)
          this.newArray = finalArray;
      } else {
        for (let i = 0; i < maxQuestions; i++) {
          finalArray.push(i + 1);
        }
        this.newArray = finalArray;
      }
    },
    startQuizMethod() {
      $('.quizloader').show();
      let quizListUrlLink = root.pubIvUnitInfo.link + this.quizInfo.connected_to_unit + '/';
      const quizStartedApiLink = root.pubIvUnitSubmittedLink.link
      axios.get(quizListUrlLink).then(response => {
        if (response.status === 200) {
          this.sectionQuestionListResults = response.data.data.questions
          this.sectionQuestion = response.data.data.questions
          
          this.sectionByTotalTime =  this.sectionQuestionListResults[this.questionIndex].estimated_solve_time

          var totalTimes = new Date();
          totalTimes.setSeconds(totalTimes.getSeconds() + this.sectionByTotalTime);
          this.initializeTimer(totalTimes);
          
          this.quizSectionShow = false;
          this.QuizStart = true
          // this.getCounter()
          $('.quizloader').hide();
          this.openFullscreen();
          axios.post(quizStartedApiLink, {id:this.quizId})
        }
      }).catch(err => {
        toast.error("Contest doesn't exist");
        // this.$router.go(-1);
        $('.quizloader').hide();
      })
    },
    submitQuiz() {
      clearInterval(this.downloadTimer);
      this.countdownTimerForFullScreenInterval = false
      $('.quizloader').show();
      let quizCreateAnswerLink = root.pubIvContestSubmitApiList.link;
      let data = {
        quiz: this.quizId,
        questions: this.quizResponses,
        // time_taken: (this.sectionByTotalTime * 1000 - this.CountDown.total) / 1000,
        user:this.quizInfo.connected_to_user
      };
      axios.post(quizCreateAnswerLink, data).then(response => {
        this.quizSubmitted = true;
        this.totalScore = response.data.data.points_obtained;
        
        $('.quizloader').hide();
      }).catch(err => {
        // console.error(err);
        $('.quizloader').hide();
      })
    },
    selectOption(index, optionData, questionId) {
      this.selectedQuestionId = questionId
      this.selectedOptionData = optionData
      this.selectedQuestionIndex = index
      if (this.selectedOptionData != this.selectedOptionId) {
        this.selectedOptionId = this.selectedOptionData
        Vue.set(this.userResponses, this.questionIndex, this.selectedQuestionIndex);
        this.skipQuestion = false
      } else {
        Vue.delete(this.userResponses, this.questionIndex, this.selectedQuestionIndex);
        this.selectedOptionData = '',
          this.selectedQuestionId = '',
          this.selectedQuestionIndex = '',
          this.selectedOptionId = '',
          this.skipQuestion = true
      }
    },
    next() {
      clearInterval(this.timeinterval);
      if (this.questionIndex + 1 == this.sectionQuestionListResults.length) {
        this.score()
      } else if (this.questionIndex < this.sectionQuestionListResults.length) {
        this.questionIndex++;
        
        setTimeout(() => {
          this.sectionByTotalTime =  this.sectionQuestionListResults[this.questionIndex].estimated_solve_time
          let totalTimes = new Date();
          totalTimes.setSeconds(totalTimes.getSeconds() + this.sectionByTotalTime);
          this.initializeTimer(totalTimes);
        },1)
        
        // this.getCounter();
        this.skipQuestion = true
        // this.renderMathJax()
      }
      if (this.selectedQuestionId && this.selectedOptionData) {
        this.quizResponses.push({
          "question": this.selectedQuestionId,
          "options": [{
            "option": this.selectedOptionData
          }],
          "time_taken": (this.sectionByTotalTime * 1000 - this.CountDown.total) / 1000,
        })
        this.selectedQuestionId = ''
        this.selectedOptionData = ''
      }
    },
    prev() {
      if (this.sectionQuestionListResults.length > 0) this.questionIndex--;
      // this.renderMathJax()
    },
    // Return "true" count in userResponses
    score() {
      this.submitQuiz();
    },
    // All Section  CountDown
    initializeTimer(endTime) {
      // console.log(endTime, "Contest End Time")
      var _self = this;
      
      function updateClock() {
        let remainTime = _self.getTimeRemaining(endTime)
        _self.CountDown = remainTime;
        // _self.UpdatePercentage(remainTime.total);
        // console.log('Time End Before')
        if (remainTime.total <= 0 && _self.quizSubmitted == false) {
            _self.next();
          // _self.submitQuiz();
          // console.log('Time End')
          clearInterval(_self.timeinterval);
        }
      }
      updateClock();
      _self.timeinterval = setInterval(updateClock, 1000);
    },
    getTimeRemaining(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
  },
  beforeDestroy() {
    clearInterval(this.timeinterval);
    clearInterval(interval);
    document.removeEventListener("fullscreenchange", this.exitFullscreenHandler);
    document.removeEventListener("webkitfullscreenchange", this.exitFullscreenHandler);
    document.removeEventListener("mozfullscreenchange", this.exitFullscreenHandler);
    document.removeEventListener("MSFullscreenChange", this.exitFullscreenHandler);
  },
  created() {},
}